import { Button, Modal } from 'react-bootstrap';
import React, { useState } from 'react';
import { useDispatch } from 'react-redux';
import { getReportPayrolls, paidReportPayroll } from 'src/store/actions/reportPayroll-actions';

import { toast } from 'react-toastify';
import { IReportPayroll } from 'src/types/reportPayroll';
import { changeToZeroMomentDate } from '../../../../../../../helpers/timeHelpers';
import moment from 'moment';

interface Props {
    data: IReportPayroll;
}

const PaidPayrollAction: React.FunctionComponent<Props> = ({ data: { id, status, periodStart, periodEnd } }: Props) => {
    const dispatch = useDispatch();
    const [opened, setOpened] = useState(false);
    const [success, setSuccess] = useState(false);
    const handleClose = () => {
        setOpened(false);
    };

    return (
        <>
            {success ? null : (
                <button type="button" onClick={() => setOpened(true)} className="btn-primary btn">
                    $ Paid
                </button>
            )}

            <Modal show={opened} onHide={handleClose}>
                <Modal.Header closeButton>
                    <Modal.Title>Confirmation</Modal.Title>
                </Modal.Header>
                <Modal.Body>Are you sure you want to pay Payroll?</Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={handleClose}>
                        Cancel
                    </Button>
                    <Button
                        variant="danger"
                        onClick={() =>
                            dispatch(
                                paidReportPayroll(
                                    {
                                        dateFrom: changeToZeroMomentDate(periodStart?.date),
                                        dateTo: changeToZeroMomentDate(periodEnd?.date),
                                    },
                                    () => {
                                        toast.success('Status changed successfully');
                                        dispatch(
                                            getReportPayrolls({
                                                page: 1,
                                                itemsPerPage: 20,
                                                pagination: 1,
                                                filters: {
                                                    dateTo: changeToZeroMomentDate(undefined),
                                                    dateFrom: moment().subtract(3, 'months').format('YYYY-MM-DD'),
                                                },
                                            }),
                                        );
                                        setSuccess(true);
                                        setOpened(false);
                                    },
                                    (errorMessage: string) => {
                                        setOpened(false);
                                        toast.error(errorMessage);
                                    },
                                ),
                            )
                        }
                    >
                        Yes
                    </Button>
                </Modal.Footer>
            </Modal>
        </>
    );
};

export default PaidPayrollAction;
